/**
 * Tokens Material Design 3 Expressive — espelhados do app mobile.
 * @see sinalario-de-libras-bilingua-hub/src/app/providers/theme/md3Expressive.ts
 */
export const md3Expressive = {
  shape: {
    none: 0,
    extraSmall: 4,
    small: 8,
    medium: 12,
    large: 16,
    extraLarge: 28,
    full: 9999,
  },
  /** Escala Bilíngua (Manrope) — alinhada a `shared/styles/typography.ts`. */
  typography: {
    displayMedium: { fontSize: 45, lineHeight: 52, fontWeight: 700 },
    headlineLarge: { fontSize: 33, lineHeight: 56, fontWeight: 700 },
    headlineMedium: { fontSize: 28, lineHeight: 41, fontWeight: 700 },
    titleLarge: { fontSize: 24, lineHeight: 41, fontWeight: 700 },
    titleMedium: { fontSize: 19, lineHeight: 32, fontWeight: 600 },
    bodyLarge: { fontSize: 19, lineHeight: 32, fontWeight: 400 },
    bodyMedium: { fontSize: 14, lineHeight: 24, fontWeight: 400 },
    labelLarge: { fontSize: 14, lineHeight: 24, fontWeight: 600 },
    labelMedium: { fontSize: 12, lineHeight: 19, fontWeight: 600 },
  },
  stateLayer: {
    hover: 0.08,
    focus: 0.12,
    pressed: 0.12,
    dragged: 0.16,
  },
  motion: {
    scheme: "expressive" as const,
    duration: {
      short1: 50,
      short2: 100,
      short3: 150,
      short4: 200,
      medium1: 250,
      medium2: 300,
      medium3: 350,
      medium4: 400,
    },
    scale: {
      pressed: 0.98,
      pressedExpressive: 0.96,
      emphasis: 1.02,
      emphasisExpressive: 1.04,
    },
    easing: {
      standard: "cubic-bezier(0.2, 0, 0, 1)",
      emphasized: "cubic-bezier(0.2, 0, 0, 1)",
      expressive: "cubic-bezier(0.34, 1.56, 0.64, 1)",
    },
  },
  elevation: {
    level0: "none",
    level1: "0 1px 3px rgba(0, 0, 0, 0.12)",
    level2: "0 2px 6px rgba(0, 0, 0, 0.16)",
    level3: "0 4px 8px rgba(0, 0, 0, 0.2)",
  },
  components: {
    filledButton: {
      minHeight: 48,
      minHeightLarge: 56,
      paddingHorizontal: 24,
      shape: "full" as const,
    },
    outlinedButton: {
      minHeight: 48,
      outlineWidth: 1,
      shape: "full" as const,
    },
    outlinedTextField: {
      minHeight: 56,
      outlineWidth: 1,
      shape: "medium" as const,
    },
    card: {
      shape: "extraLarge" as const,
    },
  },
} as const;

export type Md3Expressive = typeof md3Expressive;
